import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Accordion } from "react-bootstrap";
import faqsImage from "../Assets/faqsimage.svg";
import "./General.css";

const Faqswithdrawal = () => {
  return (
    <div className="General-page">
      <div className="General-section">
        <h1>Withdrawals</h1>
        <div>
          <div>
            <Accordion
              defaultActiveKey="1"
              flush
              className="General-background"
            >
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <h6 className="accordion-text">
                    When can I withdraw my money?
                  </h6>
                </Accordion.Header>
                <Accordion.Body className="accordion-bodyText">
                  <p>
                    You can only withdraw at the set maturity date. You can
                    choose to withdraw some or all of your capital together with
                    the interest. You can decide to rollover the plan for
                    another period or withdraw part or everything you have
                    invested.
                  </p>
                  <p className="mt-3">
                    Rolling over matured plans for another period makes it
                    possible to enjoy compound returns.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
          <div>
            <Accordion
              defaultActiveKey="0"
              flush
              className="General-background-one"
            >
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  <h6 className="accordion-text">
                    What are the withdrawal options?
                  </h6>
                </Accordion.Header>
                <Accordion.Body className="accordion-bodyText">
                  <div>
                    <p>
                      There are basically 3 options to withdrawing your money
                      after maturity.
                    </p>
                    <p className="mt-3">Here are the 3 withdrawal options:</p>
                    <p>1. Withdraw Capital and Interest Only.</p>
                    <p>2. Withdraw Capital Only</p>
                    <p>3. Withdraw Interest Only.</p>
                  </div>
                  <div>
                    <p>However, if you wish to re-invest, you can</p>
                    <p>1. Re-invest all of your funds</p>
                    <p>2. Add more capital to your funds and re-invest.</p>
                    <p>
                      *If you have not added your bank details, tap “My
                      Profile”. Under “Banks”, provide details of the preferred
                      bank account to be credited and save the details. If
                      withdrawal is not settled after six hours, don’t hesitate
                      to send us a message on any of our channels: Emails,
                      Twitter, Instagram, Email or Live Chat.
                    </p>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faqswithdrawal;
